module.exports = __webpack_public_path__ + "img/Creating.a5c5a1d7.svg";